import React, { useEffect, useState } from "react";
import defImage from "@3gaam/shared/assets/images/def-image.png";

type Props = {
  src: string | undefined;
  defSrc?: string | undefined;
  className?: string | undefined;
  alt?: string | undefined;
  srcSet?: string | undefined;
};
const Image = ({ src, defSrc, className, alt, srcSet }: Props) => {
  const [error, setError] = useState(false);
  const [imgSrc, setImgSrc] = useState<any>(src);

  useEffect(() => {
    setImgSrc(src || defSrc || defImage);
  }, [src, defSrc]);

  const onError = () => {
    if (!error) {
      setImgSrc(defSrc || defImage);
      setError(true);
    }
  };

  return (
    <img
      src={imgSrc}
      srcSet={srcSet}
      className={className}
      alt={alt}
      onError={onError}
    />
  );
};

export default Image;
